export function isCardsSubscription(row) {
  return [row.subscription_model, row.model_type].some(
    (model) =>
      String(model || '')
        .trim()
        .toLowerCase() === 'cards'
  );
}

export function subscriptionDateTimestamp(value) {
  if (value == null || value === '') return null;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
}

export function formatSubscriptionDate(value) {
  const timestamp = subscriptionDateTimestamp(value);
  if (timestamp == null) return '\u2014';
  const date = new Date(timestamp);
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${month}-${day}-${date.getUTCFullYear()}`;
}
